import axios from "axios";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Pagination } from "antd";
import Spinner from "../common/Spinner";
import DesignItem from "./DesignItem";

const Designs = ({ search, language, labels }) => {
  const [current, setCurrent] = useState(1);
  const [designs, setDesigns] = useState([]);
  const { resultLabel } = labels;
  let lang = "";
  if (language == 0) lang = "Kp";
  if (language == 1) lang = "En";
  if (language == 2) lang = "Cn";
  if (language == 3) lang = "Ru";

  useEffect(() => {
    axios
      .get(`/api/design?search=${search}&language=${language}`)
      .then((res) => {
        setDesigns(res.data);
      })
      .catch();
  }, [search]);

  useEffect(() => {
    axios
      .post(`/api/log`, {
        title: "공업도안",
        lang: lang,
        type: "기사",
      })
      .then((res) => {
        // setMarks(res.data);
        // console.log(res.data);
      })
      .catch();
  }, []);

  let designItems;

  if (designs === null) {
    designItems = <Spinner />;
  } else {
    if (designs.length > 0) {
      designItems = designs
        .slice((current - 1) * 4, current * 4)
        .map((design) => <DesignItem key={design._id} design={design} />);
    } else {
      designItems = <></>;
    }
  }

  return (
    <div className="design">
      <img
        className="w-100"
        src="./assets/design_banner.jpg"
        alt="dprk intellectual property association"
      />
      <div className="container pt-5">
        <div className="d-flex flex-column">
          {/* <p className="mb-5">
            {resultLabel[language]}:&nbsp;
            {designs ? designs.length : "0"}
          </p> */}
          <div className="d-flex flex-wrap justify-content-around design-item-space">
            {designItems}
          </div>
        </div>
        <div className="d-flex justify-content-center py-5">
          <Pagination
            defaultCurrent={1}
            total={designs ? designs.length : 0}
            pageSize={4}
            showSizeChanger={false}
            onChange={(page) => {
              setCurrent(page);
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  search: state.profile.search,
  language: state.profile.language,
  labels: state.labels,
});

export default connect(mapStateToProps, {})(Designs);
